import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';
import { fade, makeStyles, withStyles } from '@material-ui/core/styles';
import TreeView from '@material-ui/lab/TreeView';
import TreeItem from '@material-ui/lab/TreeItem';
import Collapse from '@material-ui/core/Collapse';
import { useRef, useEffect, useState, useCallback, memo } from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Slider from '@material-ui/core/Slider';
import NonLinearSlider from './NonLinearSlider';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        flexDirection: "column",
        whiteSpace: "nowrap"
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
    sliderRoot: {
        margin: "8px 15px 2px 30px",
        width: "100%",
        width: "-moz-available",
        width: "-webkit-fill-available",
        width: "fill-available",
    },
    labels: {
        padding: "0px 16px 0px 16px"
    }
}));

const StyledSlider = withStyles({
    thumb: {
        height: 24,
        width: 24,
        backgroundColor: '#fff',
        border: '2px solid currentColor',
        marginTop: -6,
        marginLeft: -12,
        '&:focus, &:hover, &$active': {
            boxShadow: 'inherit',
        },
    },
    track: {
        height: 12,
        borderRadius: 4,
    },
    rail: {
        height: 12,
        borderRadius: 4,
    },
    valueLabel: {
        left: 'calc(-50% + 4px)',
    },
    mark: {
        height: 2,
        width: 1,
        marginTop: 5,
    }
})(Slider);

const FilterSimples = ({ filterData, setFilter, label, setCnt  }) => {
    const classes = useStyles();
    const [value, setValue] = React.useState([0, 0]);
    const [lookup, setLookup] = React.useState();
    
    const [timer, setTimer] = useState(null);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        if (filterData != null && filterData.exclusionFilters != null) {
            let prices = filterData.exclusionFilters.children.find(a => a.label == label);
            if (prices != null && prices.children != null) {
                let numericPrices = prices.children.map(a => { return { cnt: a.count, from: a.from, orig: a } });
                numericPrices.push({ from: 100000000, cnt: 0 });

                let normalized = numericPrices.sort((a, b) => a.origValue - b.origValue).map((a, i) => {
                    return {
                        value: i,
                        cnt: a.cnt,
                        from: a.from,
                        orig: a.orig
                    };
                });
                if (value[0] == 0 && value[1] == 0) {
                    setValue([0, normalized.length - 1]);
                }
                let n = JSON.stringify(lookup);
                let n2 = JSON.stringify(normalized);
                if (n != n2) {
                    setLookup(normalized);
                    console.log("only fire on filters change");
                }
            }
        }
    }, [filterData, lookup]);

    useEffect(() => {
        if (value != null && lookup != null && value[0] != value[1]) {
            let sum = 0;
            for (let i = value[0]; i < value[1]; i++) {
                sum += lookup[i].cnt;
            }
            setCnt(sum);
            debounce(() => {
                let f1 = lookup[value[0]].from;
                let f2 = lookup[value[1]].from;
                let newFilter = {
                    displayText: `${f1}-${f2}`,
                    field: label,
                    from: f1,
                    id: `xxx-slider-${label}`,
                    label: `${f1}-${f2}`,
                    to: f2,
                    type: "Range",
                }
                setFilter(filters => [...(filters.filter(a => a.id != newFilter.id)), newFilter])
            }, 400);
        }
    }, [value, lookup]);

    const render = (v) => {
        if (lookup != null) {
            let l = lookup[v];
            if (l != null) {
                let a = l.from;
                if (a <= 1)
                    return "0";
                if (a < 10000) {
                    return `${a}`;
                }
                if (a < 1000000) {
                    return `${a / 1000}K`
                }
                if (a > 10000000) {
                    return '\u221E';
                }
                return `${a / 1000000}M`
            }
        }
    }

    const debounce = (method, delayMs) => {
        delayMs = delayMs || 250;
        setTimer(null);
        clearTimeout(timer);
        var t = setTimeout(() => {
            method()
        }, delayMs);
        setTimer(t);
    }

    if (filterData != null && filterData.filters != null && lookup != null) {
        return (
            <>
                <div style={{ width: "100%" }}>
                    <Typography className={classes.labels} id="range-slider" gutterBottom>
                        {label}
                    </Typography>

                    <StyledSlider className={classes.sliderRoot}
                        value={value}
                        onChange={handleChange}
                        valueLabelDisplay="auto"
                        track={false}
                        aria-labelledby="range-slider"
                        step={null}
                        marks={lookup}
                        min={0}
                        max={lookup.length - 1}
                        valueLabelFormat={render}
                    />
                </div>
            </>
        );
    }
    else {
        return <div />
    }

};

export default memo(FilterSimples);

